import React from "react";

const UnsavedChangesModal = ({
  open,
  title = "You Have Unsaved Changes",
  message = "What would you like to do with your changes?",
  onSave,
  onDiscard,
  onReview,
  saveLabel = "SAVE & CONTINUE",
  discardLabel = "DISCARD CHANGES & CONTINUE",
  reviewLabel = "REVIEW CHANGES",
  onSaveAndRedirect,
  onRedirectWithoutSaving,
  onCancel,
  saving = false,
}) => {
  if (!open) return null;

  const handleSave = onSave || onSaveAndRedirect;
  const handleDiscard = onDiscard || onRedirectWithoutSaving;
  const handleReview = onReview || onCancel;

  return (
    <div className="fixed inset-0 z-[110] flex items-center justify-center bg-black/40 px-4">
      <div className="w-full max-w-[610px] rounded bg-white px-6 py-7 shadow-xl sm:px-7">
        <div className="mb-8">
          <h2 className="text-[18px] font-medium text-[#3b3b3b]">{title}</h2>
          <p className="mt-6 text-[15px] text-[#3f3f46]">{message}</p>
        </div>

        <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-4">
          <button
            type="button"
            onClick={handleSave}
            disabled={saving}
            className="inline-flex min-h-[36px] items-center justify-center rounded bg-[#f7e5e2] px-4 text-[14px] font-medium text-[#e14d37] transition-colors hover:bg-[#f3d9d4] disabled:cursor-not-allowed disabled:opacity-60"
          >
            {saving ? "SAVING..." : saveLabel}
          </button>
          <button
            type="button"
            onClick={handleDiscard}
            disabled={saving}
            className="inline-flex min-h-[36px] items-center justify-center rounded px-1 text-[14px] font-medium text-[#3f3f46] transition-colors hover:text-black disabled:cursor-not-allowed disabled:opacity-60"
          >
            {discardLabel}
          </button>
          <button
            type="button"
            onClick={handleReview}
            disabled={saving}
            className="inline-flex min-h-[36px] items-center justify-center rounded bg-[#f3f4f6] px-4 text-[14px] font-medium text-[#3f3f46] transition-colors hover:bg-[#e8eaee] disabled:cursor-not-allowed disabled:opacity-60"
          >
            {reviewLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default UnsavedChangesModal;
